<div class="modal-header" (click)="$event.stopPropagation()">
  <h4 class="modal-title">{{title}}</h4>
  <button class="close-modal" title="Close" (click)="onDismiss()">
    <svg><use xlink:href="#icon-cancel"></use></svg>
  </button>
</div>

<div class="modal-body">
  <div [innerHTML]="message"></div>

  <div class="rename-item" *ngIf="!isPerformingAction">
    <div class="form-container" [ngClass]="{'W100PC': inputSuffix === undefined || inputSuffix?.length === 0}">
      <div class="input">
        <input type="text" [(ngModel)]="inputText" [placeholder]="inputTextPlaceholder">
      </div>
    </div>
    <div class="item-extension" *ngIf="inputSuffix?.length > 0">
      <span class="suffix" >{{inputSuffix}}</span>
    </div>
  </div>
  <div class="home-tabs-loader" *ngIf="isPerformingAction">
    <div class="loader"></div>
        <p>Performing requested action...</p>
  </div>
</div>
<div class="modal-footer">
  <ng-container *ngIf="!isPerformingAction">
      <button type="button" class="dialog-btn dialog-primary" (click)="onAccept()" [disabled]="isDisabledActionBtn">{{actionBtnText}}</button>
      <button type="button" class="dialog-btn dialog-secondary" *ngIf="declineBtnText?.length > 0" (click)="onDecline()">{{declineBtnText}}</button>
  </ng-container>
</div>

